module.exports = __webpack_public_path__ + "img/torba-na-przewod-do-ladowania.b86fa676.jpg";